import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { usePortalAuth } from "../../context/PortalAuthContext";
import Loader from "../Loader";

export default function PortalProtectedRoute({ children }) {
  const { isAuthenticated, loading } = usePortalAuth();
  const location = useLocation();

  if (loading) return <Loader />;
  if (!isAuthenticated) {
    return <Navigate to="/portal/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
